import { atom, getDefaultStore, useAtomValue } from 'jotai';
import { DsUserInsights } from '../types';

export const userDsInsightsAtom = atom<DsUserInsights>();
export const msIdAtom = atom<string | undefined>();

export const useDsUserInsights = () => {
  return useAtomValue(userDsInsightsAtom);
};

export const useMsIdAtomValue = () => {
  return useAtomValue(msIdAtom);
};

export const setMsIdAtom = (msId: string) => {
  const store = getDefaultStore();
  store.set(msIdAtom, msId);
};

export const resetDsUserInsights = () => {
  const store = getDefaultStore();
  store.set(userDsInsightsAtom, undefined);
};

export const initUserDsInsights = () => {
  const store = getDefaultStore();
  store.set(userDsInsightsAtom, {
    storeName: { summary: '', status: 'PENDING' },
    businessOverview: { summary: '', status: 'PENDING' },
    storeLookAndFeel: { summary: '', status: 'PENDING' },
    contactDetails: { summary: '', status: 'PENDING' },
  });
};

export const setStoreName = (name: string) => {
  const store = getDefaultStore();
  const currentInsights = store.get(userDsInsightsAtom);
  store.set(userDsInsightsAtom, {
    ...currentInsights,
    storeName: { summary: name, status: 'PROVIDED' },
  });
};
